require( "isomorphic-fetch" );

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clientGetFetcher = async (api, params) => {

    const url = process.env.NEXT_PUBLIC_MKPS_PUBLICKEYED_BASE_URL + api + ( ( params ) ? "?" + params.toString() : "" );

    const dataResponse = await fetch(
        url,
        {
            headers: {
                "mkps-api-key": process.env.NEXT_PUBLIC_MKPS_PUBLIC_API_KEY,
                "Accept": "application/json"
            }
        }
    );

    return( dataResponse.json() );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clientGetAuthenticatedFetcher = async (api, params) => {

    const url = process.env.NEXT_PUBLIC_MKPS_PUBLICKEYED_BASE_URL + "authenticated/" + api;

    const session = document.cookie
        .split("; ")
        .find((row) => row.startsWith("stytch_session="))
        ?.split("=")[1];

    const dataResponse = await fetch(
        url,
        {
            headers: {
                "mkps-api-key": process.env.NEXT_PUBLIC_MKPS_PUBLIC_API_KEY,
                "mkps-bearer": session,
                "Accept": "application/json"
            }
        }
    );

    return( dataResponse.json() );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clientPostFetcher = async (api, data) => {

    const url = process.env.NEXT_PUBLIC_MKPS_PUBLICKEYED_BASE_URL + api;

    const dataResponse = await fetch(
        url,
        {
            method: "POST",
            headers: {
                "mkps-api-key": process.env.NEXT_PUBLIC_MKPS_PUBLIC_API_KEY,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: data ? JSON.stringify( data ) : data
        }
    );

    if ( dataResponse.status !== 200 ) {
        return( { statusCode: dataResponse.status } );
    }

    return( dataResponse.json() );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clientPostAuthenticatedFetcher = async (api, data, extendedBearerType, extendedBearer) => {

    const url = process.env.NEXT_PUBLIC_MKPS_PUBLICKEYED_BASE_URL + "authenticated/" + api;

    const session = document.cookie
        .split("; ")
        .find((row) => row.startsWith("stytch_session="))
        ?.split("=")[1];

    const dataResponse = await fetch(
        url,
        {
            method: "POST",
            headers: {
                "mkps-api-key": process.env.NEXT_PUBLIC_MKPS_PUBLIC_API_KEY,
                "mkps-bearer": session,
                "mkps-extended-bearer-type": extendedBearerType,
                "mkps-extended-bearer": extendedBearer,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify( data )
        }
    );

    if ( dataResponse.status !== 200 ) {
        return( { statusCode: dataResponse.status } );
    }

    return( dataResponse.json() );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clientPostAuthenticatedFetcherWhenAlreadySignedIn = async (api, data, dataType) => {

    const url = process.env.NEXT_PUBLIC_MKPS_PUBLICKEYED_BASE_URL + "authenticated/" + api;

    const session = document.cookie
        .split("; ")
        .find((row) => row.startsWith("stytch_session="))
        ?.split("=")[1];

    const dataResponse = await fetch(
        url,
        {
            method: "POST",
            headers: {
                "mkps-api-key": process.env.NEXT_PUBLIC_MKPS_PUBLIC_API_KEY,
                "mkps-bearer": session,
                "Content-Type": dataType ? dataType : "application/json",
                "Accept": "application/json"
            },
            body: data ? ( dataType === undefined || dataType === "application/json" ) ? JSON.stringify( data ) : data : undefined
        }
    );

    if ( dataResponse.status !== 200 ) {
        return( { statusCode: dataResponse.status } );
    }

    return( dataResponse.json() );
}
